export default __webpack_public_path__ + "static/media/gel-campestra-1.0b1027b9.jpg";